export interface Invitation {
    invitationId : number,
    status : number,
    statusName : string,
    userId : number,
    legalEntityId : number,
    legalEntityName : string,
    createdAt: Date,
    expiresAt: Date,
    isExpired: boolean
}

export enum InvitationStatus {
    Expired = -1,
    Pending = 0,
    Accepted = 1,
    Rejected = 2,
    Cancelled = 3
}

export class IInvitationListingItem {
    invitationId: number;
    legalEntityName: string;
    expiresAt: string;
    status: InvitationStatus;
    isExpired : boolean
}
